import type { caisseExtra as Fr } from '../fr/caisseExtra';

/** « caisseExtra » in English — typed on the French: a missing sentence does not compile. */
export const caisseExtra: typeof Fr = {
  modes: {
    especes: 'Cash', cheque: 'Cheque', virement: 'Bank transfer', carte: 'Card', traite: 'Bill of exchange',
  },
  erreurChargement: 'Extra cash could not be loaded.',
  ligneEnregistree: 'Line recorded.',
  enregistrementImpossible: 'Could not be recorded',
  videe: 'Extra cash emptied.',
  transfertImpossible: 'Transfer not possible',
  erreurTitre: 'Extra cash cannot be displayed',
  titre: 'Extra cash',
  sousTitre: 'A free-form cash box: your words, your amounts. Empty it whenever you like.',
  ajouterLigne: 'Add a line',
  vider: 'Empty extra cash',
  kpi: {
    dedans: 'What is in it', devises: 'Currencies', vide: 'empty',
    lignes: 'Lines', lignesDetail: 'the last 400',
  },
  historique: 'What has gone through it',
  videTitre: 'Extra cash is empty',
  videTexte: 'It is for anything that fits no other box: a deposit, side income, an advance to be settled later. The description is yours.',
  colonnes: { date: 'Date', libelle: 'Description', nature: 'Type', payeEn: 'Paid by', par: 'By', montant: 'Amount' },
  saisie: {
    entre: 'Money coming in', sort: 'Money going out',
    libelle: 'Description', libelleAide: 'Your own words. This is what you will read again in six months.',
    libelleExemple: 'Partner\'s deposit, side income…',
    montant: 'Amount', devise: 'Currency', payeEn: 'Paid by',
  },
  vidage: {
    ilYA: 'There is ',
    enDevise: (devise) => ` in ${devise} in extra cash.`,
    versCaisse: 'To the cash register', versBanque: 'To the bank', ailleurs: 'Elsewhere',
    ouVa: 'Where is this money going?', libelle: 'Description',
    ouVaAide: 'Required: money out with no reason can never be traced.', facultatif: 'Optional.',
    ouVaErreur: 'Say where this money is going.',
    exempleDehors: 'Handed to the owner, paid to the supplier…',
    exempleLibelle: 'Extra cash emptied',
    titreDehors: 'The money leaves the agency',
    titrePoche: 'The money changes pockets',
    texteDehors: 'This sum will leave the agency\'s accounts. It will not reappear in the cash register or the bank: only the reason will say what became of it.',
    textePoche: (versBanque) => `Two linked lines will be written: money out of extra cash, money into ${versBanque ? 'the bank' : 'the cash register'}. The agency's total does not change.`,
    bouton: 'Empty',
  },
};
